import { render, staticRenderFns } from "./Paymentgetwaymgmt.vue?vue&type=template&id=3b341e84&"
import script from "./Paymentgetwaymgmt.vue?vue&type=script&lang=js&"
export * from "./Paymentgetwaymgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports